import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { ShieldCheckIcon, UsersIcon, MapIcon } from 'lucide-react';
export function AboutSection() {
  return <section className="py-20 bg-slate-50" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-18">
          {/* Text Content */}
          <div className="lg:w-1/2" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-20">
              About Universal Global Logistics
            </h2>

            <div className="space-y-4 text-slate-600 text-lg leading-relaxed mb-8" data-id="element-21">
              <p data-id="element-22">
                Universal Global Logistics is a specialist provider of emergency
                parcel and item delivery services across the UK.
              </p>
              <p data-id="element-23">
                We operate as an emergency delivery driving agency, supplying
                reliable and professional drivers to meet a wide range of
                delivery needs at short notice.
              </p>
              <p data-id="element-24">
                Our logistics solutions support businesses and individuals
                requiring urgent transport, relocation assistance, furniture
                delivery, or long-term driver support.
              </p>
              <p data-id="element-25">
                With a nationwide network and experienced team, we ensure every
                delivery is handled efficiently, safely, and professionally.
              </p>
            </div>

            <Link to="/about" data-id="element-26">
              <Button variant="outline" size="lg" className="bg-white" data-id="element-27">
                Learn More About Us
              </Button>
            </Link>
          </div>

          {/* Decorative Visual */}
          <div className="lg:w-1/2 w-full" data-id="element-28">
            <div className="grid grid-cols-2 gap-4" data-id="element-29">
              <img src="https://images.unsplash.com/photo-1580674285054-bed31e145f59?w=800" alt="Female delivery driver" className="w-full h-64 object-cover rounded-2xl shadow-md" data-id="element-30" />
              <img src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=800" alt="Delivery driver" className="w-full h-64 object-cover rounded-2xl shadow-md mt-8" data-id="element-31" />
              <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800" alt="Logistics warehouse" className="w-full h-48 object-cover rounded-2xl shadow-md col-span-2" data-id="element-32" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}